import { stylesPath } from '@/Common/Environment/const';

export class FontLoaderModule {
	static allFonts: Common.IMap<string> = {
		FontAwesome5Brands: `${stylesPath}/theme/lib/fonts/fa-brands-400.woff`,
		FontAwesome5Free: `${stylesPath}/theme/lib/fonts/fa-solid-900.woff`,
		'element-icons': `${stylesPath}/theme/lib/fonts/element-icons.woff`
	};

	loadAllFonts(): void {
		const { allFonts } = FontLoaderModule;

		const fontNames: Array<string> = Object.keys(allFonts);

		fontNames.forEach((fontName) => {
			new FontFace(fontName, `url(${allFonts[fontName]})`)
				.load()
				.then((loadedFace) => document.fonts.add(loadedFace))
				.catch((err: Error) => {
					// eslint-disable-next-line no-console
					console.warn(`cannot load font ${fontName} `, err);
				});
		});
	}
}

const fontLoaderModule = new FontLoaderModule();

export default fontLoaderModule;
